import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Link } from '@material-ui/core';
import MarketReimbursementReport from './MarketReimbursementReport';
import PropertyReimbursementReport from './PropertyReimbursementReport';
import NewHireEmployeeReport from './NewHireEmployee';
import TerminatedEmployeeReport from './TerminatedEmployeeReport';
import ChangeInAllocationEmployeeByProperty from './ChangeInAllocationEmployeeByProperty';
import ChangeInAllocationEmployeeByMarket from './ChangeInAllocationEmployeeByMarket';
import PageHeader from '../common/PageHeader';
import { IsDataCenterMarket, IsSectionVisible, IsSensitiveDataAccess } from '../../utils/helper';
import { SECTIONS } from '../../constants/appConstants';
import ReimbursementVarianceAnalysis from '../ReimbursementVarianceAnalysis/ReimbursementVarianceAnalysis';
import PropertyAllocationSummary from './PropertyAllocationSummary';
import EmployeeReimbursementsBilledAmount from './EmployeeReimbursementsBilledAmount';
import PropertyVarianceDetails from './PropertyVarianceDetails';
import MarketAllocationSummary from './MarketAllocationSummary';
import SDCInvoiceReport from './SDCInvoiceReport';
import DatacenterPropertyReimbursementReport from './DatacenterPropertyReimbursementReport';
import YearEndBonusReport from './YearEndBonusReport';
import ARReimbursementCostReport from './ARReimbursementCostReport';
import PropTypes from 'prop-types';
import { apiBatchRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import UnmappedReport from './UnmappedReport';
import DatacenterPropertyVarianceDetalis from './DatacenterPropertyVarianceDetalis';
import MarketVarianceDetalis from './MarketVarianceDetalis';
import YearEndBonusMarketReimbursementReport from './YearEndBonusMarketReimbursementReport';
import PTFDetailReport from './PTFDetailReport';

function createData(reportType, report, action) {
  const finalVisibleReports = report.filter(x => x.isVisible === true);
  if (finalVisibleReports && finalVisibleReports.length > 0) {
    return { reportType, report, action };
  }
}

const Getrows = () => {
  return [
    createData(
      'Property Accounting Reports',
      getPropertyAccounting(),
      ''
    ),
    createData(
      'Corporate Accounting Reports',
      getCorporateAccounting(),
      ''
    ),
    createData(
      'Employee Reports',
      employeeTabs(),
      ''
    ),
    createData(
      'Variance Analysis',
      [
        {
          name: 'Reimbursement Variance Analysis Report',
          child: <ReimbursementVarianceAnalysis />,
          isVisible: IsSectionVisible(SECTIONS.REPORTS, SECTIONS.MARKET_REIMBURSEMENT_VARIANCE_ANALYSIS) || IsSectionVisible(SECTIONS.REPORTS, SECTIONS.PROPERTY_REIMBURSEMENT_VARIANCE_ANALYSIS)

        }
      ],
      ''
    ),
    createData(
      'Datacenter Reports',
      sDCReportTabs(),
      ''
    ),
    createData(
      'Year End Bonus Reports',
      yearEndBonusReport(),
      ''
    ),
    createData(
      'Centralized AR Admin Reports',
      arReimbursementCostReport(),
      ''
    ),
    createData(
      'PTF Reports',
      ptfReport(),
      ''
    )
  ];
};

function getPropertyAccounting() {
  const propertyAccounting = [];
  if (IsSensitiveDataAccess() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Property_Reimbursement_Report)) {
    propertyAccounting.push({
      name: 'Property Reimbursement Report',
      child: <PropertyReimbursementReport />,
      isVisible: true
    });
  }
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Property_Allocation_Summary)) {
    propertyAccounting.push({
      name: 'Property Allocation Summary Report',
      child: <PropertyAllocationSummary />,
      isVisible: true
    });
  }

  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Property_Variance_Detail_Report)) {
    propertyAccounting.push({
      name: 'Property Variance Detail Report',
      child: <PropertyVarianceDetails />,
      isVisible: true
    });
  }
  return propertyAccounting;
}

function getCorporateAccounting() {
  const corporateAccounting = [];
  if (IsSensitiveDataAccess() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Market_Reimbursement_Report)) {
    corporateAccounting.push({
      name: 'Market Reimbursement Report',
      child: <MarketReimbursementReport />,
      isVisible: true
    });
  }
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Market_Allocation_Summary)) {
    corporateAccounting.push({
      name: 'Market Allocation Summary Report',
      child: <MarketAllocationSummary />,
      isVisible: true
    });
  }

  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Market_Variance_Detail_Report)) {
    corporateAccounting.push({
      name: 'Market Variance Detail Report',
      child: <MarketVarianceDetalis />,
      isVisible: true
    });
  }

  return corporateAccounting;
}

function sDCReportTabs() {
  const sdcTab = [];
  if (IsSensitiveDataAccess() && IsDataCenterMarket() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Datacenter_Invoice_Report)) {
    sdcTab.push({
      name: 'Datacenter Invoice Report',
      child: <SDCInvoiceReport />,
      isVisible: true
    });
  }
  if (IsSensitiveDataAccess() && IsDataCenterMarket() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Datacenter_Property_Reimbursement_Report)) {
    sdcTab.push({
      name: 'Datacenter Property Reimbursement Report',
      child: <DatacenterPropertyReimbursementReport />,
      isVisible: true
    });
  }
  if (IsSensitiveDataAccess() && IsDataCenterMarket() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Datacenter_Property_Variance_Detail_Report)) {
    sdcTab.push({
      name: 'Datacenter Property Variance Detail Report',
      child: <DatacenterPropertyVarianceDetalis />,
      isVisible: true
    });
  }

  return sdcTab;
}

function employeeTabs() {
  const empTab = [];
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Employee_New_Hire_Report)) {
    empTab.push({
      name: 'Employee New Hire Report',
      child: <NewHireEmployeeReport />,
      isVisible: true
    });
  }
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Employee_Termination_Report)) {
    empTab.push({
      name: 'Employee Termination Report',
      child: <TerminatedEmployeeReport />,
      isVisible: true
    });
  }
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Employee_Allocation_Change_by_Market_Report)) {
    empTab.push({
      name: 'Employee Allocation Activity by Market Report',
      child: <ChangeInAllocationEmployeeByMarket />,
      isVisible: true
    });
  }
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Employee_Allocation_Change_by_Property_Report)) {
    empTab.push({
      name: 'Employee Allocation Activity by Property Report',
      child: <ChangeInAllocationEmployeeByProperty />,
      isVisible: true
    });
  }
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Employee_Reimbursements_Billed_Amount)) {
    empTab.push({
      name: 'Employee Reimbursements Billed Amounts',
      child: <EmployeeReimbursementsBilledAmount />,
      isVisible: true
    });
  }
  return empTab;
}

function yearEndBonusReport() {
  const yearEndBonusTab = [];
  if (IsSensitiveDataAccess() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.YEAR_END_BONUS_REPORT)) {
    yearEndBonusTab.push({
      name: 'Year End Bonus Report',
      child: <YearEndBonusReport />,
      isVisible: true
    });
  }

  if (IsSensitiveDataAccess() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.Year_End_Bonus_Market_Reimbursement_Report)) {
    yearEndBonusTab.push({
      name: 'Year End Bonus Market Reimbursement Report',
      child: <YearEndBonusMarketReimbursementReport />,
      isVisible: true
    });
  }

  return yearEndBonusTab;
}

function arReimbursementCostReport() {
  const arCenterializedTab = [];
  if (IsSensitiveDataAccess() && IsSectionVisible(SECTIONS.REPORTS, SECTIONS.CENTERALIZED_AR_REIMBURSEMENT_REPORT)) {
    arCenterializedTab.push({
      name: 'Centralized AR Reimbursement Report',
      child: <ARReimbursementCostReport />,
      isVisible: true
    });
  }

  return arCenterializedTab;
}

function ptfReport() {
  const ptfReportTab = [];
  if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.PTF_DETAIL_REPORT)) {
    ptfReportTab.push({
      name: 'PTF Detail Report',
      child: <PTFDetailReport />,
      isVisible: true
    });
  }

  return ptfReportTab;
}

class BasicTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      p: '',
      reload: this.props.reload,
      tabDetails: []
    };
  }

  componentDidMount() {
    this.LoadData();
  }

  static getDerivedStateFromProps(newProps, state) {
    if ((newProps || {}).reload !== (state || {}).reload) {
      return {
        p: '',
        reload: newProps.reload
      };
    }
    return null;
  }

  LoadData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Json.GetReportConfiguration,
        key: 'reportConfiguration'
      }
    ])
      .then(
        ({
          reportConfiguration
        }) => {
          this._asyncRequest = null;
          if (reportConfiguration.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          const tabDetails = (Getrows() || []);
          if (reportConfiguration.rawData?.length > 0) {
            reportConfiguration.data?.map(x => {
              const childReports = reportConfiguration.rawData?.filter(config => config.ParentSectionId === x.SectionId);
              const report = [];
              childReports.map(child => {
                if (IsSectionVisible(SECTIONS.REPORTS, child.SectionId)) {
                  report.push({
                    name: child.SectionName,
                    isVisible: true,
                    child: <UnmappedReport sectionId={child.SectionId} sectionName={child.SectionName} reportURL={child.ReportURL} />
                  });
                }
                return child;
              });
              if (report.length > 0) {
                tabDetails.push({
                  reportType: x.SectionName,
                  report,
                  action: ''
                });
              }

              return x;
            });
          }

          this.setState({
            tabDetails
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  handleClick = (index, i, child) => {
    this.setState({ p: child });
  };

  render() {
    const { tabDetails } = this.state;
    return (

      this.state.p !== ''
        ? this.state.p.child
        : <>
          <PageHeader title={'Reports'}></PageHeader>
          <TableContainer component={Paper} style={{ marginTop: '10px' }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Report Type </TableCell>
                  <TableCell align="left">Report Name</TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {((tabDetails || []).filter(x => x !== undefined) || []).map((row, index) => (
                  <TableRow key={row.reportType}>
                    <TableCell component="th" scope="row">
                      {row.reportType}
                    </TableCell>
                    <TableCell align="left">
                      {row.report.map((cal, i) => (
                        <p key={i}>
                          <Link style={{ cursor: 'pointer' }} key={i} onClick={() => this.handleClick(index, i, cal)} to="">
                            {cal.name}
                          </Link>
                        </p>
                      ))}
                    </TableCell>
                    <TableCell align="left">{row.action}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
    );
  }
}

export default BasicTable;

BasicTable.propTypes = {
  reload: PropTypes.bool
};
